export const settingsSections = [
  {
    id: "account",
    title: "Account & data",
    description: "Email, saved data and signed-in devices",
  },
  {
    id: "security",
    title: "Password & security",
    description: "Change your password",
  },
  {
    id: "notifications",
    title: "Notifications",
    description: "Choose notifications for this device",
  },
  {
    id: "privacy",
    title: "Privacy controls",
    description: "Guest messages, reminders and blocked players",
  },
  {
    id: "updates",
    title: "Your updates",
    description: "Messages and activity for you",
  },
  {
    id: "feedback",
    title: "Help & feedback",
    description: "Tell us what needs attention",
  },
  {
    id: "handicap",
    title: "Handicap information",
    description: "Understand the calculations",
  },
  {
    id: "delete",
    title: "Delete account",
    description: "Manage your account and personal data",
  },
] as const;
export type SettingsSectionId = (typeof settingsSections)[number]["id"];
